import {createContext, FC, PropsWithChildren} from "react";
import {useImmer} from "use-immer";

const ModalContext = createContext<{
  modalIds: string[];
  setModalId(id: string): void;
  deleteModalId(id: string): void;
}>({
  modalIds: [],
  setModalId: (_id: string) => void 0,
  deleteModalId: (_id: string) => void 0,
});

const ModalProvider: FC<PropsWithChildren> = ({children}) => {
  const [modalIds, setModalIds] = useImmer<string[]>([]);

  return (
    <ModalContext.Provider
      value={{
        modalIds,
        setModalId: id => {
          setModalIds(state => {
            state.push(id);
          });
        },
        deleteModalId: id => {
          setModalIds(state => {
            state.splice(state.indexOf(id), 1);
          });
        },
      }}>
      {children}
    </ModalContext.Provider>
  );
};

export {ModalContext, ModalProvider};
